import isNetworkError from 'is-network-error'

const shouldErrorBeLoggedToSentry = (error: Error) => {
  const errorName = error.name
  const cause = error?.cause

  if (
    typeof cause === 'object' &&
    cause !== null &&
    'status' in cause &&
    cause.status === 504
  ) {
    return false
  }

  return errorName !== 'AbortError' && !isNetworkError(error)
}

export default shouldErrorBeLoggedToSentry
